import {Brand} from '../Brand';
import {chatiwiBase} from './chatiwiBase';
import {ChatiwiLogo} from './ChatiwiLogo';

export const chatiwi: Brand = {
  ...chatiwiBase,
  assets: {
    logo: ChatiwiLogo,
  },
};
